module.exports = __webpack_public_path__ + "img/yihuajiemu.85638996.png";